import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue';
import { onMounted, onUnmounted } from 'vue';
import useHero, { selectedLiveStream, LiveStreamProvider } from "@/components/useHero";
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const {LPVideoPlayer, YTVideoPlayer} = useHero()

const showVideoStreamInPip = async () => {
  if(window.pageYOffset > 50 || router.currentRoute.value.name === "Schedule") {
    
    if (selectedLiveStream.value === LiveStreamProvider.LP) {
      LPVideoPlayer.value.player.requestPictureInPicture()
      LPVideoPlayer.value
    }

    if (selectedLiveStream.value === LiveStreamProvider.YT) {
      YTVideoPlayer.value
    }
  }


  if(window.pageYOffset < 50 && document.pictureInPictureElement && router.currentRoute.value.name === "MainPage") {
    await document.exitPictureInPicture();
  }
}

onMounted(async () => {
  window.addEventListener("scroll", showVideoStreamInPip, { passive: true });

})

onUnmounted(() => {
  window.removeEventListener("scroll", showVideoStreamInPip);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ]))
}
}

})